module.exports = __webpack_public_path__ + "img/timer.28cd342a.svg";